function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.8846 0C25.5965 0 27 1.40355 27 3.11538V23.8846C27 25.5965 25.5965 27 23.8846 27H3.11538C1.40355 27 0 25.5965 0 23.8846V3.11538C0 1.40355 1.40355 0 3.11538 0H23.8846ZM23.8846 2.07692H3.11538C2.53125 2.07692 2.07692 2.53125 2.07692 3.11538V23.8846C2.07692 24.4688 2.53125 24.9231 3.11538 24.9231H23.8846C24.4688 24.9231 24.9231 24.4688 24.9231 23.8846V3.11538C24.9231 2.53125 24.4688 2.07692 23.8846 2.07692ZM14.5385 6.23077V12.4615H6.23077V6.23077H14.5385ZM20.7692 8.30769V10.3846H16.6154V8.30769H20.7692ZM12.4615 8.30769H8.30769V10.3846H12.4615V8.30769ZM14.5385 14.5385V20.7692H6.23077V14.5385H14.5385ZM20.7692 16.6154V18.6923H16.6154V16.6154H20.7692ZM12.4615 16.6154H8.30769V18.6923H12.4615V16.6154Z",
  fill: "#01A6C7"
});

const SvgMpi = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgMpi, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/MPI.f62a05ff.svg";
export { ForwardRef as ReactComponent };